export const NAME = "ast-base-transforms";

function stripProperties(remains) {
    const properties_list = remains.stripChildren("semantic-map__properties");
    const property_list = remains.stripChildren("semantic-map__property");

    const properties = {};

    if (properties_list) {
        Object.assign(properties, ...properties_list);
    }

    if (property_list) {
        Object.assign(properties, ...property_list);
    }

    return properties;
}

function stripFeatures(remains) {
    const features_list = remains.stripChildren("semantic-map__features");
    const feature_list = remains.stripChildren("semantic-map__feature");

    let features = [];

    if (features_list) {
        features = features.concat(features_list.flat(2));
    }

    if (feature_list) {
        features = features.concat(feature_list.flat());
    }

    return features;
}

const base_transforms_ordered = [
    [ "semantic-map__attribution", remains => remains.getInnerHTML() ],
    [ "semantic-map__properties", remains => remains.stripAttribute("properties", true) ],
    [ "semantic-map__property", remains => {
        const key = remains.stripAttribute("property-key", true);
        const value = remains.stripAttribute("property-value") || remains.getInnerHTML();
        remains.stripAttribute("property-parser"); // just so it's gone

        const property = {};

        property[key] = value;

        return property;
    } ],
    [ "semantic-map__geometries", remains => remains.stripAttribute("geometries", true) ],
    [ "semantic-map__geometry", remains => {
        const type = remains.stripAttribute("geometry-type", true);
        const geometries_list = remains.stripChildren("semantic-map__geometries");
        const geometry_list = remains.stripChildren("semantic-map__geometry");

        if (type == "GeometryCollection") {
            if (!geometries_list && !geometry_list) {
                throw "a 'GeometryCollection' needs to have child geometries";
            }

            let geometries = undefined;

            if (geometries_list && geometry_list) {
                geometries = geometries_list.flat().concat(geometry_list);
            } else if (geometries_list) {
                geometries = geometries_list.flat();
            } else {
                geometries = geometry_list;
            }

            return { type, geometries };
        } else {
            const coordinates = remains.stripAttribute("geometry-coordinates", true);

            return { type, coordinates };
        }
    } ],
    [ "semantic-map__features", remains => remains.stripAttribute("features", true) ],
    [ "semantic-map__feature", remains => ({
        type: "Feature",
        geometry: remains.stripChildren("semantic-map__geometry", true, true),
        properties: stripProperties(remains),
    }) ],
    [ "semantic-map-context", remains => ({
        ref: remains.stripAttribute("ref") || 0,
        props: {
            // ...stripProperties(remains),
            geojson_features: stripFeatures(remains),
        },
    }) ],
    [ "semantic-map", remains => ({
        node: remains.getNode(),
        id: remains.stripAttribute("id") || "",
        props: {
            // ...properties: stripProperties(remains),
            attribution: remains.stripChildren("semantic-map__attribution", false, true),
            clustering_enabled: remains.stripAttribute("enable-clustering"),
            initial_center: remains.stripAttribute("initial-center", true),
            initial_zoom: remains.stripAttribute("initial-zoom", true),
            min_zoom: remains.stripAttribute("min-zoom"),
            max_zoom: remains.stripAttribute("max-zoom"),
            tile_url_template: remains.stripAttribute("tile-url-template", true),
            geojson_features: stripFeatures(remains),
        },
    }) ],
];

export const base_transforms_order = base_transforms_ordered.map(t => t[0]);

export const base_transforms = base_transforms_ordered.reduce((a, t) => {
    a[t[0]] = t[1];

    return a;
}, {});
